module.exports = __webpack_public_path__ + "img/pre-university-coding.29624b56.png";